enum FieldSection {
  STANDARD_DATA = 'standard_data',
  LOCATION = 'location',
  IDS_AND_RELATIONS = 'ids_and_relations',
  CUSTOMER_SPECIFIC = 'customer_specific',
  SOURCE_LINK = 'source_link',
  MULTI_CURRENCY = 'multi_currency'
}

export default FieldSection
